import React, { useEffect, useState } from "react";
// import RTE from "react-rte";
import ReactQuill from "react-quill";
import { GrammarlyEditorPlugin } from "@grammarly/editor-sdk-react";
import styles from "./RichTextEditor.module.css";
import "react-quill/dist/quill.snow.css";

const modules = {
  toolbar: [
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],
    ["link"],
  ],
};

function RichTextEditor(props) {
  const [value, setValue] = useState(props.value || "");
  const [firstUpdate, setFirstUpdate] = useState(true);

  useEffect(() => {
    if (props.value && firstUpdate) {
      setValue(props.value);
      setFirstUpdate(false);
    }
  }, [props.value, firstUpdate]);

  const handleChange = (value) => {
    setValue(value);
    props.onChange(value);
  };

  return (
    <GrammarlyEditorPlugin clientId="client_Bd3T1c2LZFN2fLkpGArWk7">
      <ReactQuill
        // defaultValue={props.value}
        placeholder={props.placeholder}
        className={styles.rte}
        value={value}
        onChange={handleChange}
        modules={modules}
      />
    </GrammarlyEditorPlugin>
  );

  // return (
  //     <RTE
  //       value={value}
  //       toolbarConfig={toolbarConfig}
  //       onChange={handleChange}
  //       className={styles.rte}
  //       placeholder={props.placeholder}
  //     />
  // );
}

export default RichTextEditor;
